package er.prateek.crossly.ui.achievements

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.size
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import crossly.shared.generated.resources.Res
import crossly.shared.generated.resources.badge_brainstormer
import crossly.shared.generated.resources.badge_brainstormer_desc
import crossly.shared.generated.resources.badge_first_daily
import crossly.shared.generated.resources.badge_first_daily_desc
import crossly.shared.generated.resources.badge_first_numbers
import crossly.shared.generated.resources.badge_first_numbers_desc
import crossly.shared.generated.resources.badge_first_riddles
import crossly.shared.generated.resources.badge_first_riddles_desc
import crossly.shared.generated.resources.badge_first_words
import crossly.shared.generated.resources.badge_first_words_desc
import crossly.shared.generated.resources.badge_flawless
import crossly.shared.generated.resources.badge_flawless_desc
import crossly.shared.generated.resources.badge_perfectionist
import crossly.shared.generated.resources.badge_perfectionist_desc
import crossly.shared.generated.resources.badge_phoenix
import crossly.shared.generated.resources.badge_phoenix_desc
import crossly.shared.generated.resources.badge_solved_10
import crossly.shared.generated.resources.badge_solved_10_desc
import crossly.shared.generated.resources.badge_solved_150
import crossly.shared.generated.resources.badge_solved_150_desc
import crossly.shared.generated.resources.badge_solved_50
import crossly.shared.generated.resources.badge_solved_50_desc
import crossly.shared.generated.resources.badge_streak_100
import crossly.shared.generated.resources.badge_streak_100_desc
import crossly.shared.generated.resources.badge_streak_3
import crossly.shared.generated.resources.badge_streak_30
import crossly.shared.generated.resources.badge_streak_30_desc
import crossly.shared.generated.resources.badge_streak_3_desc
import crossly.shared.generated.resources.badge_streak_7
import crossly.shared.generated.resources.badge_streak_7_desc
import crossly.shared.generated.resources.badge_triple_threat
import crossly.shared.generated.resources.badge_triple_threat_desc
import crossly.shared.generated.resources.badge_solved_5
import crossly.shared.generated.resources.badge_solved_5_desc
import crossly.shared.generated.resources.badge_solved_25
import crossly.shared.generated.resources.badge_solved_25_desc
import crossly.shared.generated.resources.badge_solved_300
import crossly.shared.generated.resources.badge_solved_300_desc
import crossly.shared.generated.resources.badge_solved_500
import crossly.shared.generated.resources.badge_solved_500_desc
import crossly.shared.generated.resources.badge_words_10
import crossly.shared.generated.resources.badge_words_10_desc
import crossly.shared.generated.resources.badge_words_50
import crossly.shared.generated.resources.badge_words_50_desc
import crossly.shared.generated.resources.badge_numbers_10
import crossly.shared.generated.resources.badge_numbers_10_desc
import crossly.shared.generated.resources.badge_numbers_50
import crossly.shared.generated.resources.badge_numbers_50_desc
import crossly.shared.generated.resources.badge_riddles_10
import crossly.shared.generated.resources.badge_riddles_10_desc
import crossly.shared.generated.resources.badge_riddles_50
import crossly.shared.generated.resources.badge_riddles_50_desc
import crossly.shared.generated.resources.badge_polymath
import crossly.shared.generated.resources.badge_polymath_desc
import crossly.shared.generated.resources.badge_perfect_5
import crossly.shared.generated.resources.badge_perfect_5_desc
import crossly.shared.generated.resources.badge_perfect_100
import crossly.shared.generated.resources.badge_perfect_100_desc
import crossly.shared.generated.resources.badge_streak_14
import crossly.shared.generated.resources.badge_streak_14_desc
import crossly.shared.generated.resources.badge_streak_60
import crossly.shared.generated.resources.badge_streak_60_desc
import crossly.shared.generated.resources.badge_streak_365
import crossly.shared.generated.resources.badge_streak_365_desc
import crossly.shared.generated.resources.badge_brainstorm_5
import crossly.shared.generated.resources.badge_brainstorm_5_desc
import crossly.shared.generated.resources.badge_brainstorm_25
import crossly.shared.generated.resources.badge_brainstorm_25_desc
import crossly.shared.generated.resources.badge_phoenix_3
import crossly.shared.generated.resources.badge_phoenix_3_desc
import crossly.shared.generated.resources.rarity_common
import crossly.shared.generated.resources.rarity_epic
import crossly.shared.generated.resources.rarity_legendary
import crossly.shared.generated.resources.rarity_rare
import er.prateek.crossly.progression.achievements.Achievement
import er.prateek.crossly.progression.achievements.AchievementRarity
import er.prateek.crossly.ui.components.IconBulb
import er.prateek.crossly.ui.components.IconFlame
import er.prateek.crossly.ui.components.IconLock
import er.prateek.crossly.ui.components.IconReplay
import er.prateek.crossly.ui.components.IconStar
import er.prateek.crossly.ui.components.IconTrophy
import er.prateek.crossly.ui.theme.game
import er.prateek.crossly.ui.theme.mixWith
import org.jetbrains.compose.resources.StringResource

val Achievement.titleRes: StringResource
    get() = when (this) {
        Achievement.FIRST_WORDS -> Res.string.badge_first_words
        Achievement.FIRST_NUMBERS -> Res.string.badge_first_numbers
        Achievement.FIRST_RIDDLES -> Res.string.badge_first_riddles
        Achievement.FIRST_DAILY -> Res.string.badge_first_daily
        Achievement.FLAWLESS -> Res.string.badge_flawless
        Achievement.STREAK_3 -> Res.string.badge_streak_3
        Achievement.TRIPLE_THREAT -> Res.string.badge_triple_threat
        Achievement.STREAK_7 -> Res.string.badge_streak_7
        Achievement.SOLVED_10 -> Res.string.badge_solved_10
        Achievement.BRAINSTORMER -> Res.string.badge_brainstormer
        Achievement.PHOENIX -> Res.string.badge_phoenix
        Achievement.PERFECTIONIST -> Res.string.badge_perfectionist
        Achievement.SOLVED_50 -> Res.string.badge_solved_50
        Achievement.STREAK_30 -> Res.string.badge_streak_30
        Achievement.SOLVED_150 -> Res.string.badge_solved_150
        Achievement.STREAK_100 -> Res.string.badge_streak_100
        Achievement.SOLVED_5 -> Res.string.badge_solved_5
        Achievement.SOLVED_25 -> Res.string.badge_solved_25
        Achievement.SOLVED_300 -> Res.string.badge_solved_300
        Achievement.SOLVED_500 -> Res.string.badge_solved_500
        Achievement.WORDS_10 -> Res.string.badge_words_10
        Achievement.WORDS_50 -> Res.string.badge_words_50
        Achievement.NUMBERS_10 -> Res.string.badge_numbers_10
        Achievement.NUMBERS_50 -> Res.string.badge_numbers_50
        Achievement.RIDDLES_10 -> Res.string.badge_riddles_10
        Achievement.RIDDLES_50 -> Res.string.badge_riddles_50
        Achievement.POLYMATH -> Res.string.badge_polymath
        Achievement.PERFECT_5 -> Res.string.badge_perfect_5
        Achievement.PERFECT_100 -> Res.string.badge_perfect_100
        Achievement.STREAK_14 -> Res.string.badge_streak_14
        Achievement.STREAK_60 -> Res.string.badge_streak_60
        Achievement.STREAK_365 -> Res.string.badge_streak_365
        Achievement.BRAINSTORM_5 -> Res.string.badge_brainstorm_5
        Achievement.BRAINSTORM_25 -> Res.string.badge_brainstorm_25
        Achievement.PHOENIX_3 -> Res.string.badge_phoenix_3
    }

val Achievement.descriptionRes: StringResource
    get() = when (this) {
        Achievement.FIRST_WORDS -> Res.string.badge_first_words_desc
        Achievement.FIRST_NUMBERS -> Res.string.badge_first_numbers_desc
        Achievement.FIRST_RIDDLES -> Res.string.badge_first_riddles_desc
        Achievement.FIRST_DAILY -> Res.string.badge_first_daily_desc
        Achievement.FLAWLESS -> Res.string.badge_flawless_desc
        Achievement.STREAK_3 -> Res.string.badge_streak_3_desc
        Achievement.TRIPLE_THREAT -> Res.string.badge_triple_threat_desc
        Achievement.STREAK_7 -> Res.string.badge_streak_7_desc
        Achievement.SOLVED_10 -> Res.string.badge_solved_10_desc
        Achievement.BRAINSTORMER -> Res.string.badge_brainstormer_desc
        Achievement.PHOENIX -> Res.string.badge_phoenix_desc
        Achievement.PERFECTIONIST -> Res.string.badge_perfectionist_desc
        Achievement.SOLVED_50 -> Res.string.badge_solved_50_desc
        Achievement.STREAK_30 -> Res.string.badge_streak_30_desc
        Achievement.SOLVED_150 -> Res.string.badge_solved_150_desc
        Achievement.STREAK_100 -> Res.string.badge_streak_100_desc
        Achievement.SOLVED_5 -> Res.string.badge_solved_5_desc
        Achievement.SOLVED_25 -> Res.string.badge_solved_25_desc
        Achievement.SOLVED_300 -> Res.string.badge_solved_300_desc
        Achievement.SOLVED_500 -> Res.string.badge_solved_500_desc
        Achievement.WORDS_10 -> Res.string.badge_words_10_desc
        Achievement.WORDS_50 -> Res.string.badge_words_50_desc
        Achievement.NUMBERS_10 -> Res.string.badge_numbers_10_desc
        Achievement.NUMBERS_50 -> Res.string.badge_numbers_50_desc
        Achievement.RIDDLES_10 -> Res.string.badge_riddles_10_desc
        Achievement.RIDDLES_50 -> Res.string.badge_riddles_50_desc
        Achievement.POLYMATH -> Res.string.badge_polymath_desc
        Achievement.PERFECT_5 -> Res.string.badge_perfect_5_desc
        Achievement.PERFECT_100 -> Res.string.badge_perfect_100_desc
        Achievement.STREAK_14 -> Res.string.badge_streak_14_desc
        Achievement.STREAK_60 -> Res.string.badge_streak_60_desc
        Achievement.STREAK_365 -> Res.string.badge_streak_365_desc
        Achievement.BRAINSTORM_5 -> Res.string.badge_brainstorm_5_desc
        Achievement.BRAINSTORM_25 -> Res.string.badge_brainstorm_25_desc
        Achievement.PHOENIX_3 -> Res.string.badge_phoenix_3_desc
    }

val AchievementRarity.labelRes: StringResource
    get() = when (this) {
        AchievementRarity.COMMON -> Res.string.rarity_common
        AchievementRarity.RARE -> Res.string.rarity_rare
        AchievementRarity.EPIC -> Res.string.rarity_epic
        AchievementRarity.LEGENDARY -> Res.string.rarity_legendary
    }

/** Rarity colour, taken from the live palette so badges sit right in every theme. */
@Composable
fun AchievementRarity.color(): Color {
    val colors = MaterialTheme.game
    return when (this) {
        AchievementRarity.COMMON -> colors.success
        AchievementRarity.RARE -> colors.accent
        AchievementRarity.EPIC -> colors.accentAlt
        AchievementRarity.LEGENDARY -> colors.gold
    }
}

/**
 * A badge medal: a rarity-coloured sweep ring around a lit disc carrying the badge's emblem.
 * Locked medals render as a flat grey disc with a padlock, so the shelf previews what's coming
 * without spoiling the colour of the reward.
 */
@Composable
fun AchievementMedal(
    achievement: Achievement,
    unlocked: Boolean,
    size: Dp,
    modifier: Modifier = Modifier,
) {
    val colors = MaterialTheme.game
    val tint = achievement.rarity.color()
    Box(modifier = modifier.size(size), contentAlignment = Alignment.Center) {
        Canvas(modifier = Modifier.size(size)) {
            val radius = this.size.minDimension / 2f
            val ringWidth = radius * 0.16f
            if (unlocked) {
                drawCircle(
                    brush = Brush.radialGradient(
                        listOf(tint.mixWith(Color.White, 0.25f), tint.mixWith(Color.Black, 0.35f)),
                        center = Offset(center.x - radius * 0.3f, center.y - radius * 0.35f),
                        radius = radius * 1.4f,
                    ),
                    radius = radius - ringWidth / 2f,
                )
                drawCircle(
                    brush = Brush.sweepGradient(
                        listOf(
                            tint.mixWith(Color.White, 0.55f),
                            tint,
                            tint.mixWith(Color.Black, 0.25f),
                            tint.mixWith(Color.White, 0.55f),
                        ),
                    ),
                    radius = radius - ringWidth / 2f,
                    style = Stroke(width = ringWidth),
                )
                // Specular highlight: the one detail that makes it read as metal rather than a dot.
                drawCircle(
                    color = Color.White.copy(alpha = 0.22f),
                    radius = radius * 0.32f,
                    center = Offset(center.x - radius * 0.28f, center.y - radius * 0.32f),
                )
            } else {
                drawCircle(color = colors.locked.copy(alpha = 0.35f), radius = radius - ringWidth / 2f)
                drawCircle(
                    color = colors.locked.copy(alpha = 0.7f),
                    radius = radius - ringWidth / 2f,
                    style = Stroke(width = ringWidth * 0.6f),
                )
            }
        }
        if (unlocked) {
            MedalEmblem(achievement, size * 0.5f, Color.White)
        } else {
            IconLock(size = size * 0.36f, tint = colors.inkMuted)
        }
    }
}

@Composable
private fun MedalEmblem(achievement: Achievement, size: Dp, tint: Color) {
    val numberStyle = TextStyle(
        fontSize = (size.value * 0.42f).sp,
        fontWeight = FontWeight.Black,
        color = tint,
    )
    when (achievement) {
        Achievement.FIRST_WORDS -> GlyphEmblem("Aa", size, tint)
        Achievement.FIRST_NUMBERS -> GlyphEmblem("÷+", size, tint)
        Achievement.FIRST_RIDDLES -> GlyphEmblem("?", size, tint)
        Achievement.FIRST_DAILY -> GlyphEmblem("31", size, tint)
        Achievement.TRIPLE_THREAT -> GlyphEmblem("×3", size, tint)
        Achievement.FLAWLESS -> IconStar(size = size, tint = tint)
        Achievement.BRAINSTORMER -> IconBulb(size = size, tint = tint)
        Achievement.PHOENIX -> IconReplay(size = size * 0.9f, tint = tint)
        Achievement.STREAK_3, Achievement.STREAK_7, Achievement.STREAK_30, Achievement.STREAK_100 ->
            CountedEmblem(achievement.threshold(), numberStyle) { IconFlame(size = size * 0.7f, tint = tint) }
        Achievement.SOLVED_10, Achievement.SOLVED_50, Achievement.SOLVED_150 ->
            CountedEmblem(achievement.threshold(), numberStyle) { IconTrophy(size = size * 0.62f, tint = tint) }
        Achievement.STREAK_14, Achievement.STREAK_60, Achievement.STREAK_365 ->
            CountedEmblem(achievement.threshold(), numberStyle) { IconFlame(size = size * 0.7f, tint = tint) }
        Achievement.SOLVED_5, Achievement.SOLVED_25, Achievement.SOLVED_300, Achievement.SOLVED_500 ->
            CountedEmblem(achievement.threshold(), numberStyle) { IconTrophy(size = size * 0.62f, tint = tint) }
        Achievement.PERFECT_5, Achievement.PERFECT_100 ->
            CountedEmblem(achievement.threshold(), numberStyle) { IconStar(size = size * 0.62f, tint = tint) }
        Achievement.BRAINSTORM_5, Achievement.BRAINSTORM_25 ->
            CountedEmblem(achievement.threshold(), numberStyle) { IconBulb(size = size * 0.62f, tint = tint) }
        Achievement.PHOENIX_3 ->
            CountedEmblem(achievement.threshold(), numberStyle) { IconReplay(size = size * 0.55f, tint = tint) }
        Achievement.WORDS_10, Achievement.WORDS_50 ->
            CountedEmblem(achievement.threshold(), numberStyle) { GlyphEmblem("Aa", size * 0.8f, tint) }
        Achievement.NUMBERS_10, Achievement.NUMBERS_50 ->
            CountedEmblem(achievement.threshold(), numberStyle) { GlyphEmblem("÷+", size * 0.8f, tint) }
        Achievement.RIDDLES_10, Achievement.RIDDLES_50 ->
            CountedEmblem(achievement.threshold(), numberStyle) { GlyphEmblem("?", size * 0.8f, tint) }
        Achievement.POLYMATH -> GlyphEmblem("Σ", size, tint)
        Achievement.PERFECTIONIST ->
            CountedEmblem(achievement.threshold(), numberStyle) { IconStar(size = size * 0.62f, tint = tint) }
    }
}

private fun Achievement.threshold(): Int = when (this) {
    Achievement.STREAK_3 -> 3
    Achievement.STREAK_7 -> 7
    Achievement.STREAK_30 -> 30
    Achievement.STREAK_100 -> 100
    Achievement.SOLVED_10 -> 10
    Achievement.SOLVED_50 -> 50
    Achievement.SOLVED_150 -> 150
    Achievement.PERFECTIONIST -> 25
    Achievement.SOLVED_5 -> 5
    Achievement.SOLVED_25 -> 25
    Achievement.SOLVED_300 -> 300
    Achievement.SOLVED_500 -> 500
    Achievement.WORDS_10 -> 10
    Achievement.WORDS_50 -> 50
    Achievement.NUMBERS_10 -> 10
    Achievement.NUMBERS_50 -> 50
    Achievement.RIDDLES_10 -> 10
    Achievement.RIDDLES_50 -> 50
    Achievement.PERFECT_5 -> 5
    Achievement.PERFECT_100 -> 100
    Achievement.STREAK_14 -> 14
    Achievement.STREAK_60 -> 60
    Achievement.STREAK_365 -> 365
    Achievement.BRAINSTORM_5 -> 5
    Achievement.BRAINSTORM_25 -> 25
    Achievement.PHOENIX_3 -> 3
    else -> 0
}

@Composable
private fun GlyphEmblem(glyph: String, size: Dp, tint: Color) {
    Text(
        text = glyph,
        style = TextStyle(fontSize = (size.value * 0.62f).sp, fontWeight = FontWeight.Black, color = tint),
        maxLines = 1,
    )
}

@Composable
private fun CountedEmblem(count: Int, style: TextStyle, icon: @Composable () -> Unit) {
    Column(horizontalAlignment = Alignment.CenterHorizontally) {
        icon()
        Text(text = count.toString(), style = style, maxLines = 1)
    }
}
